export const STATE_UNCHECKED = 0
export const STATE_CHECKED = 1
export const STATE_INDETERMINATE = 2
export const SENIORITY_SELF = 0
export const SENIORITY_ANCESTOR = 1
export const SENIORITY_DESCENDANT = 2
export const BUS_TREE__SELECT = 'g-tree__select'



// WEBPACK FOOTER //
// ./src/module/tree/constants.js